import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { TopNavigationBar } from '@common/components/navigation-bar';
import { Button } from '@common/components/button';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Container from '../../../../common/components/container';
import { OrganisationForm } from '../../forms/organisation';
import * as organisationSelector from '../../../organisation/selectors/organisation';
import type { Organisation } from '../../../../common/types/objects';
import type { StoreState } from '../../../../common/types/store';
import { isPristine, isSubmitting, isValid, submit } from 'redux-form';

require('./styles.scss');

type Props = {
  t: (key: string) => string,
  organisation: Organisation,
  isFormPristine: boolean,
  isFormSubmitting: boolean,
  isFormValid: boolean,
  triggerSubmit: () => void,
};

export const OrganisationGeneralSettings = ({
  organisation,
  t,
  isFormPristine,
  isFormSubmitting,
  isFormValid,
  triggerSubmit,
}: Props) => (
  <Container name="SettingsGeneral">
    <TopNavigationBar
      title={[t('organisation:settings_index_general_title')]}
      action={
        <Button
          type="primary"
          size="large"
          onClick={triggerSubmit}
          isLoading={isFormSubmitting}
          disabled={isFormPristine || !isFormValid || isFormSubmitting}
        >
          {t('organisation:forms_organisation_submit')}
        </Button>
      }
    />
    <Container.Content>
      <OrganisationForm
        organisation={organisation}
      />
    </Container.Content>
  </Container>
);

const mapStateToProps = (state: StoreState) => ({
  organisation: organisationSelector.selected(state),
  isFormPristine: isPristine('organisation')(state),
  isFormSubmitting: isSubmitting('organisation')(state),
  isFormValid: isValid('organisation')(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  triggerSubmit: () => dispatch(submit('organisation')),
});

const mapper = connect(mapStateToProps, mapDispatchToProps);

const PageTracker = pageWrapper(EEventNames.VISITED_ORGANISATION_SETTINGS_BRANDING_PAGE)(
  OrganisationGeneralSettings
);

export const OrganisationGeneralSettingsContainer = withTranslation()(mapper(PageTracker));
